import { useQuery } from 'react-query'
import { ContactService } from '../services'

export const useContacts = (campaignId: number) => {
  return useQuery(['contacts', campaignId], () => ContactService.getContactsForCampaign(campaignId))
}
